import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { DatePipe, NgClass } from '@angular/common';
import {Store} from '@ngxs/store';
import {SubmissionState} from '../../../../shared/microservices/submission/submission.state';
import {WINDOW} from '../../../../universal/window/window.service';
import {AuthState} from '../../../../auth/states/auth/auth.state';

interface InsightsCarouselItem {
  title: string;

  url: string;

  imageSrc?: string;

  isSeparateFlow: boolean;

  absoluteURL?: boolean;

  newTab: boolean;

  disabled: boolean;

  itemWidth: number;

  visible: boolean;

  tooltip?: string;
}

@Component({
    selector: 'app-insights-index',
    templateUrl: './insights-index.component.html',
    styleUrls: ['./insights-index.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [DatePipe],
    imports: [NgClass],
})
export class InsightsIndexComponent {
  public readonly selectedSubmission$ = this.store.select(SubmissionState.selectedSubmission);
  public readonly user$ = this.store.select(AuthState.getUser);

  private moreSlidesStore: {[key: string]: InsightsCarouselItem} = {
    blog: {
      title: 'BrainKey Blog',
      url: 'blog',
      imageSrc: '/assets/images/dashboard/insights/index/blog.webp',
      isSeparateFlow: false,
      absoluteURL: true,
      newTab: false,
      disabled: false,
      itemWidth: 250,
      visible: true,
    },
    brainResearchQuestionnaire: {
      title: 'Brain Research Questionnaire',
      url: 'questionnaire',
      imageSrc: '/assets/images/dashboard/insights/index/questionnaire.webp',
      isSeparateFlow: false,
      newTab: false,
      disabled: false,
      itemWidth: 250,
      visible: true,
    },
    screenSafety: {
      title: 'Safety Screen Check',
      url: 'safety-screening',
      imageSrc: '/assets/images/dashboard/insights/index/safety-screening.webp',
      isSeparateFlow: false,
      newTab: false,
      disabled: false,
      itemWidth: 250,
      visible: false,
    },
  };

  constructor(@Inject(WINDOW) private window: Window, private route: ActivatedRoute, private router: Router, private store: Store) {}

  get moreSlidesStoreList(): InsightsCarouselItem[] {
    return Object.keys(this.moreSlidesStore)
      .map(key => this.moreSlidesStore[key])
      .filter(item => item.visible);
  }

  public navigateToSlideUrl(item: InsightsCarouselItem): void {
    if (!item.disabled) {
      if (item.newTab) {
        this.window.open(item.url, '_blank');
      } else if (item.absoluteURL) {
        this.router.navigate([`/${item.url}`]);
      } else if (item.isSeparateFlow) {
        this.router.navigate([`dashboard`, `${item.url}`]);
      } else {
        this.router.navigate([`${item.url}`], {relativeTo: this.route});
      }
    }
  }
}
